import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from "tailwind-variants";
import { useLocalStorage } from "../../hooks";
import { cn } from "../../utils";
import BannerClose from "./components/BannerClose";
// FIXME:  Ajustar espaçamento entre os elementos e alterar painel.
const bannerVariants = tv({
    base: "flex flex-row w-full justify-between relative rounded-lg p-4 gap-3",
    variants: {
        color: {
            primary: "bg-primary-3 border-primary-6 border",
            secondary: "bg-gray-3 border-gray-6 border",
            success: "bg-success-3 border-success-6 border",
            warning: "bg-warning-3 border-warning-6 border",
            danger: "bg-danger-3 border-danger-6 border",
        },
    },
    defaultVariants: {
        color: "primary",
    },
});
const Banner = ({ children, color, onClose, storageKey, className, ...props }) => {
    const [valueLocalStorage, setLocalStorage] = useLocalStorage(`ui-banner-${storageKey || "unknown"}`);
    const hasClose = onClose || storageKey;
    const handleClose = () => {
        storageKey && setLocalStorage(true);
        onClose?.();
    };
    if (valueLocalStorage) {
        return null;
    }
    return (_jsxs("div", { role: "banner", className: cn(bannerVariants({ color }), className), ...props, children: [children, hasClose && _jsx(BannerClose, { onClick: handleClose })] }));
};
export default Banner;
